















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter, Mutation, Action, namespace } from 'vuex-class';
@Component
export default class BaseInfo extends Vue {
  @Getter('getRolesAction') private rolesAction!: any;
  @Prop() private data: object[] | undefined;
  private pwdShow: boolean = false;

  /**
   * 操作列按钮点击事件, 参数(row: 所在行对象, callback: 初始化传入的按钮回调函数)
   */
  private handleButton(callback: () => void) {
    callback();
  }
}
